import merge from 'deepmerge'
import moment from 'moment'

export const saveSetting = (state, object) => {
	const settings = merge(state.settings, object)
	localStorage.setItem('shiseido-settings', JSON.stringify(settings))
	state.settings = settings
}

export const saveSettingSession = (state, object) => {
	const settings = merge(state.settings, object)
	sessionStorage.setItem('shiseido-settings', JSON.stringify(settings))
	state.settings = settings
}

export const deleteSetting = (state, key) => {
	if (state.settings[key]) delete state.settings[key]
	localStorage.setItem('shiseido-settings', JSON.stringify(state.settings))
	sessionStorage.setItem('shiseido-settings', JSON.stringify(state.settings))
}

export const login = (state, token) => {
	if (state.settings.remember) {
		localStorage.setItem('shiseido-token', token)
	} else {
		localStorage.removeItem('shiseido-token')
	}
	state.token = token
}

export const logout = (state, server) => {
	localStorage.removeItem('shiseido-token')
	state.token = null
}

export const setOptions = (state, options) => {
	state.options = options
}
export const setOptionsLoaded = (state, optionsLoaded) => {
	state.optionsLoaded = optionsLoaded
}
export const editProject = (state, project) => {
	project.year = project.installationDate ? Number(moment(project.installationDate).year()) : 'na'
	state.projects[project.id] = project
}
export const setProjects = (state, projects) => {
	state.projects = projects
}
export const addProject = (state, project) => {
	project.year = project.installationDate ? Number(moment(project.installationDate).year()) : 'na'
	// project.customId = project.customId
	state.projects[project.id] = project
}
export const removeProject = (state, id) => {
	if (state.projects[id]) {
		delete state.projects[id]
	}
}
export const addIndex = (state, index) => {
	state.indexes.push(index)
}
export const removeIndex = (state, index) => {
	state.indexes.splice(index, 1)
}
export const setIndexes = (state, indexes) => {
	state.indexes = indexes
}
export const setProjectsFile = (state, path) => {
	state.projectsFile = path
}

export const setProp = (state, prop) => {
	state.projects[prop.id][prop.option] = prop.value
	if (prop.option === 'installationDate') {
		state.projects[prop.id].age = prop.value ? moment().diff(prop.value, 'years') : 'na'
		state.projects[prop.id].year = prop.value ? Number(moment(prop.value).year()) : 'na'
	} else if (prop.option === 'totalCost') {
		state.projects[prop.id].costPerSqm = prop.value && state.projects[prop.id].sqm ? Math.round(prop.value / state.projects[prop.id].sqm) : 'na'
	} else if (prop.option === 'sqm') {
		state.projects[prop.id].costPerSqm = prop.value && state.projects[prop.id].totalCost ? Math.round(state.projects[prop.id].totalCost / prop.value) : 'na'
	}
}

export const addComment = (state, payload) => {
	state.projects[payload.projectId].comments.push(payload.comment)
}

export const flushData = (state) => {
	state.options = {
		area: [],
		brand: [],
		country: [],
		distributionChannel: [],
		generalFloorPlan: [],
		groupeSpacePlan: [],
		projectStatus: [],
		speficifNeed: [],
		typeOfProjectLabel: [],
		typeOfStore: []
	}
	state.projects = {}
	state.indexes = []
	state.projectsFile = ''
}

// Filter mutations for session persistence
export const updateFilter = (state, { key, value }) => {
	state.filters[key] = value
	sessionStorage.setItem('shiseido-filters', JSON.stringify(state.filters))
}

export const updateFilters = (state, filters) => {
	state.filters = { ...state.filters, ...filters }
	sessionStorage.setItem('shiseido-filters', JSON.stringify(state.filters))
}

export const clearFilters = (state) => {
	state.filters = {
		id: '',
		search: '',
		year: [],
		age: [],
		brand: [],
		typeOfProjectLabel: [],
		typeOfProjectType: [],
		distributionChannel: [],
		area: [],
		country: '',
		city: '',
		retailer: '',
		storeName: '',
		typeOfStore: '',
		storeLevel: '',
		beautyConsultant: [],
		totalCost: [],
		annualTurnover: [],
		sqm: [],
		costPerSqm: [],
		supplier: '',
		openRefurbish: '',
		personalizationType: '',
		furnitureType: '',
		dateOfRequest: [],
		projectStatus: [3], // Default to "On Going"
		installationDate: [],
		posClosedDate: []
	}
	sessionStorage.setItem('shiseido-filters', JSON.stringify(state.filters))
}



// WEBPACK FOOTER //
// ./src/store/mutations.js